import { H1, Wrapper } from "components/styled-components/generic";
import { FC } from "react";

const Header: FC = ({ children }) => {
  return (
    <Wrapper>
      <H1>{children}</H1>
    </Wrapper>
  );
};

export default Header;
